import Vue from 'vue'
import Store from './Store.vue'


Vue.config.productionTip = false


new Vue({
	render: h => h( Store )
}).$mount('#app')